import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { formattedSelectedGiveawayBudgetSelector, selectedGiveawayColorWithFallbackSelector } from '../../../redux/giveaway-landing/giveaway-landing.selectors';
import { GiveawayLandingCatalogSubtitle as Component } from './giveaway-landing-catalog-subtitle';
const mapStateToProps = createStructuredSelector({
  budget: formattedSelectedGiveawayBudgetSelector,
  budgetColor: selectedGiveawayColorWithFallbackSelector
});
export const GiveawayLandingCatalogSubtitle = connect(mapStateToProps)(Component);